import React from 'react';
import {
    Box,
    Container,
    Card
} from '@mui/material';
import { AppButton } from 'components/widgets/AppButton';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BuildIcon from '@mui/icons-material/Build';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { AppHeroView } from 'components/utils/AppHeroView';
import { useApp } from 'AppProvider';
import ContactUsPage from './ContactUsPage';
import { AppSectionView } from 'components/utils/AppSectionView';
import AutoSlidingView from 'components/utils/AutoSlidingView';
import AppText from 'components/widgets/AppText';

const EmergencyServicePage = () => {
    const { navigateToPage } = useApp()

    const emergencyServices = [
        {
            icon: <LocalShippingIcon fontSize="large" />,
            title: '24/7 Vehicle Transport',
            description: 'Round-the-clock emergency transport service for stranded vehicles and urgent deliveries',
        },
        {
            icon: <BuildIcon fontSize="large" />,
            title: 'Breakdown Assistance',
            description: 'On-site technical support and towing services for vehicle breakdowns',
        },
        {
            icon: <SpeedIcon fontSize="large" />,
            title: 'Quick Response',
            description: 'Rapid response team available within 2-4 hours across major routes',
        },
        {
            icon: <SupportAgentIcon fontSize="large" />,
            title: '24/7 Support',
            description: 'Dedicated support team available round the clock for emergency coordination',
        },
    ];

    const coverageAreas = [
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Bihar',
        'Chhattisgarh',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal',
        'Delhi',
        'Jammu and Kashmir',
        'Ladakh',
        'Puducherry',
        'Chandigarh',
        'Andaman and Nicobar Islands',
        'Lakshadweep',
        'Dadra and Nagar Haveli and Daman and Diu'
    ];

    const serviceFeatures = [
        'Specialized chassis transport equipment',
        'Experienced emergency response team',
        'Pan-India network of support stations',
        'Insurance coverage for emergency transport',
        'Real-time status updates',
    ];

    return (
        <Box>
            {/* Hero Section */}
            <AppHeroView
                title="24/7 Emergency Transport Services"
                description="Quick Response Team Available Across India."
                renderBottomContent={() => (
                    <AppButton color="secondary" size="large" startIcon={<PhoneInTalkIcon />} onClick={() => navigateToPage(<ContactUsPage />)}>
                        Emergency Helpline
                    </AppButton>
                )}
            />

            {/* Emergency Services Section */}
            <AppSectionView
                title="Our Emergency Services"
                items={emergencyServices} />

            {/* Coverage Area Section with Auto Sliding Cards */}
            <Container maxWidth={"lg"}>
                <AppText
                    text="Coverage Areas"
                    variant="h3"
                    align="center"
                    gutterBottom />

                <AppText
                    mb={2}
                    color={"text.secondary"}
                    text="Emergency transport services are available across key industrial and commercial corridors in India. With a pan-India network, we ensure rapid deployment of support teams and vehicles to minimize downtime and losses. Whether your fleet is stranded in a remote location or you require urgent logistics support in a metro city, our quick response team is equipped to reach you swiftly and efficiently." />

                    <Container maxWidth="md" my={4} sx={{ textAlign: "center" }}>
                        <AutoSlidingView areas={coverageAreas} />
                    </Container>
            </Container>

            <AppSectionView
                title="Why Choose Our Emergency Services?"
                description="We combine advanced technology, experienced personnel, and a robust support network to deliver reliable emergency transport solutions. Our commitment to safety, transparency, and customer satisfaction sets us apart in the logistics industry."
                items={serviceFeatures.map(feature => ({
                    icon: <CheckCircleIcon color="success" />,
                    title: feature,
                    description: '',
                }))}
            />

            {/* CTA Section */}
            <Box bgcolor={"grey.100"}>
            <Container maxWidth="md" sx={{ textAlign: "center", py: 6 }}>
                <Card>
                    <AppHeroView
                        sx={{ py: 4 }}
                        title="Need Emergency Transport?"
                        description="Our quick response team is available 24/7"
                        titleProps={{ variant: 'h4', gutterBottom: true }}
                        descriptionProps={{ variant: 'subtitle1', paragraph: true }}
                        renderBottomContent={() => (
                            <AppButton variant="contained" color="primary" size="large" startIcon={<PhoneInTalkIcon />} onClick={() => navigateToPage(<ContactUsPage />)}>
                                Contact Support
                            </AppButton>
                        )}
                    />
                </Card>
            </Container>
            </Box>
        </Box>
    );
};

export default EmergencyServicePage;